export default function EngineeringValues() {
  const values = [
    {
      label: 'Architecture',
      title: 'Clean, modular, and maintainable system design',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20top-down%20view%20of%20precisely%20arranged%20geometric%20marble%20and%20metal%20blocks%20on%20warm%20cream%20surface%2C%20minimalist%20composition%2C%20soft%20natural%20lighting%2C%20no%20people%2C%20architectural%20still%20life%2C%20clean%20lines%2C%20sophisticated%20aesthetic&width=800&height=600&seq=value-card-01-technopankai&orientation=landscape',
    },
    {
      label: 'Performance',
      title: 'Optimized execution and responsive user experiences',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20close-up%20of%20concentric%20glass%20rings%20with%20light%20refraction%2C%20warm%20amber%20and%20cream%20tones%2C%20precision%20optical%20aesthetic%2C%20no%20people%2C%20minimalist%20studio%20photography%2C%20soft%20diffused%20backlighting%2C%20clean%20geometric%20forms&width=800&height=600&seq=value-card-02-technopankai&orientation=landscape',
    },
    {
      label: 'Usability',
      title: 'User-centered design with intuitive interaction patterns',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20smooth%20sculpted%20ceramic%20form%20with%20gentle%20curves%20under%20soft%20warm%20lighting%2C%20minimalist%20product%20design%2C%20cream%20and%20charcoal%20palette%2C%20no%20people%2C%20tactile%20material%20study%2C%20ergonomic%20aesthetic%2C%20clean%20composition&width=800&height=600&seq=value-card-03-technopankai&orientation=landscape',
    },
  ];

  return (
    <section className="relative w-full py-24 md:py-32 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-20 mb-16 md:mb-20">
          <div className="lg:w-5/12">
            <div className="flex flex-col gap-3">
              <span className="font-heading text-4xl md:text-5xl font-bold text-secondary-300">Values</span>
              <span className="font-heading text-4xl md:text-5xl font-bold italic text-foreground-950">that define us</span>
            </div>
          </div>
          <div className="lg:w-7/12">
            <p className="font-body text-base md:text-lg text-foreground-600 leading-relaxed">
              Our engineering culture is built on a foundation of principles that guide every decision we make. From architecture choices to deployment strategies, these values ensure consistency, quality, and long-term thinking across all our work.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {values.map((value) => (
            <div key={value.label} className="flex flex-col gap-4">
              <div className="relative overflow-hidden rounded-xl aspect-[4/3]">
                <img
                  src={value.image}
                  alt={value.label}
                  title={`${value.label} — engineering value`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <span className="font-label text-xs tracking-widest uppercase text-accent-600 bg-accent-100/80 px-3 py-1 rounded-full self-start">
                {value.label}
              </span>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 leading-snug">
                {value.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}